/* unplugin-vue-components disabled */import script from "./Partner.vue?vue&type=script&setup=true&lang=ts"
export * from "./Partner.vue?vue&type=script&setup=true&lang=ts"

import "./Partner.vue?vue&type=style&index=0&id=388d1183&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-388d1183"]])

export default __exports__